export default function isassigned(state = false, action) {
  if (action.type === 'hasbeenassigned') {
    return state = true;
  } else if (action.type === 'hasbeenunassigned') {
    return state = false;
  } else {
    return state;
  }
}
